<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button *ngIf="flashcard && !isAudioPlaying()" (click)="vocalize()">
        <ion-icon *ngIf="!loadingAudio" name="volume-high-outline"></ion-icon>
        <ion-spinner *ngIf="loadingAudio"></ion-spinner>
      </ion-button>
      <ion-button *ngIf="flashcard && isAudioPlaying()" (click)="stopAudio()">
        <ion-icon name="stop-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="1200">
        <div *ngIf="flashcard">
          <div *ngIf="!showBack" class="front">
            <h1>{{ flashcard.root_word }}</h1>
            <ion-button id="flip-button" expand="block" (click)="flip()">{{ 'STUDY.FLIP' | translate }}</ion-button>
          </div>
          <div *ngIf="showBack" class="back">
            <h1>{{ flashcard.root_word }}</h1>
            <h2 class="translation">{{ flashcard.translation }} </h2>
            <ion-list>
              <ion-item *ngFor="let ex of flashcard.examples; let i = index">
                <ion-label>
                  <p class="example">{{ ex }}</p>
                  <p class="example-translation">{{ flashcard.example_translations[i] }}</p>
                </ion-label>
              </ion-item>
            </ion-list>
            <ion-row id="answer-buttons">
              <ion-col>
                <ion-button (click)="onAnswer(2)" expand="block" color="danger"> {{ 'STUDY.HARD' | translate }} </ion-button>
              </ion-col>
              <ion-col>
                <ion-button (click)="onAnswer(3)" expand="block" color="warning"> {{ 'STUDY.DIFFICULT' | translate }} </ion-button>
              </ion-col>
              <ion-col>
                <ion-button (click)="onAnswer(4)" expand="block" color="success"> {{ 'STUDY.GOOD' | translate }} </ion-button>
              </ion-col>
              <ion-col>
                <ion-button (click)="onAnswer(5)" expand="block" color="primary"> {{ 'STUDY.EASY' | translate }} </ion-button>
              </ion-col>
            </ion-row>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>